import React, { Component } from 'react';

class Login extends Component {
  componentDidMount() {   
    this.showButton()
  }

  buttonSettings = () => {
    return {
      type: 'PwA',
      color: 'Gold',
      size: 'medium',
      authorization: () => {
        const loginOptions = {
          scope: 'payments:widget',
          popup: true
        }
        window.amazon.Login.authorize(loginOptions, (res) => {
          if (res.status !== 'complete') return
          this.props.displayWallet()
        })
      },
      onError: (error) => {
        console.log(error.getErrorMessage())
      }
    }
  }

  showButton () {
    const { sellerId, buttonId } = this.props
    window.OffAmazonPayments.Button(buttonId, sellerId, this.buttonSettings());
  }

  render() {
    const disabled = {
      pointerEvents: 'none',
      opacity: .8
    }

    return (
      <div className="login-button" style={this.props.disabled && disabled}>
        <div id={this.props.buttonId} />
      </div>
    )
  }
}

export default Login;